import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RequireQueryParamsSeguradorasGuard {

    private readonly _router = inject(Router);

    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): boolean | UrlTree {

      const idIntegracao = next.queryParamMap.get('idIntegracao');
      const nome = next.queryParamMap.get('nome');
      const ramo = next.queryParamMap.get('ramo');

      const hasAnyParam = idIntegracao || nome || ramo;

      if (hasAnyParam && (!idIntegracao || !nome || !ramo)) {
        return this._router.parseUrl('/');
      }

      return true;
    }
}
